import {connect} from 'react-redux';
import {compose} from 'redux';
import {SearchBar} from './LEGACY_SearchBar';
import {setSearchText} from '../../redux/actions/search.actions';
import {getAutocompleteResults} from '../../redux/reducers/search.reducer';
import {selectSearchText} from '../../redux/selectors/search.selectors';
import {push} from 'connected-react-router';
import {generateRoutePath} from '@epic-core/common';
import {WithWindow} from '../../hocs';
import {mapMessageStateToProps} from '../message/Message';
import React from 'react';

const mapStateToProps = state => ({
    text: selectSearchText(state),
    searchResults: getAutocompleteResults(state.get('search')),
    ...mapMessageStateToProps(state)
});

const mapDispatchToProps = {
    setSearchText,
    search: query => push(generateRoutePath(`/store-search?q=${query}`))
};

const SearchBarContainerCompose: (component: React.ElementType) => React.ElementType = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    WithWindow
);

export const SearchBarContainer = SearchBarContainerCompose(SearchBar);
